import { ApiService } from './api.service'

export type EmployeeProfile = {
  userId: string
  firstName?: string
  lastName?: string
  function?: string
  startDate?: string
  isActive?: boolean
  salutation?: string
  title?: string
  workHoursPerWeek?: number
  vacationDays?: number
  shoeSize?: string
  clothingSize?: string
  workEmail?: string
  privateEmail?: string
  phoneWork?: string
  phoneMobile?: string
  phonePrivate?: string
  addressStreet?: string
  addressPostalCode?: string
  addressCity?: string
  addressCountry?: string
  notes?: string
  createdAt?: string
  updatedAt?: string
}

export type EmployeeFile = {
  id: string
  userId: string
  category?: string
  originalName: string
  mimeType: string
  size: number
  createdAt: string
}

export class PersonnelService extends ApiService {
  async getEmployeeProfile(userId: string): Promise<EmployeeProfile> {
    return this.handleResponse(this.api.get<EmployeeProfile>(`/users/${userId}/profile`))
  }

  async upsertEmployeeProfile(
    userId: string,
    profile: Partial<EmployeeProfile>
  ): Promise<EmployeeProfile> {
    return this.handleResponse(this.api.put<EmployeeProfile>(`/users/${userId}/profile`, profile))
  }

  async listEmployeeFiles(userId: string): Promise<EmployeeFile[]> {
    return this.handleResponse(this.api.get<EmployeeFile[]>(`/users/${userId}/files`))
  }

  async uploadEmployeeFiles(params: {
    userId: string
    files: File[]
    category?: string
  }): Promise<EmployeeFile[]> {
    const { userId, files, category } = params
    const form = new FormData()
    if (category) form.append('category', category)
    for (const f of files) form.append('files', f)
    return this.handleResponse(
      this.api.post<EmployeeFile[]>(`/users/${userId}/files`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
    )
  }

  async deleteEmployeeFile(userId: string, fileId: string): Promise<void> {
    return this.handleResponse(this.api.delete<void>(`/users/${userId}/files/${fileId}`))
  }

  async downloadEmployeeFile(params: { userId: string; fileId: string }): Promise<Blob> {
    const { userId, fileId } = params
    const res = await this.api.get(`/users/${userId}/files/${fileId}/download`, {
      responseType: 'blob',
    })
    return res.data as Blob
  }
}

export const personnelService = new PersonnelService()

